import { AccountCircle, ArrowDropDown, ArrowDropUp } from '@mui/icons-material';
import { Box, ButtonBase, Typography } from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Image from 'next/image';
import { signOut, useSession } from 'next-auth/react';
import React, { useState } from 'react';
import { UserTabStyles as styles } from './header.style';
import { EngagementEvents, logKariusEvent } from '../Analytics';

export function UserTab() {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { data: session, status } = useSession();

  if (status !== 'authenticated') {
    return null;
  }

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    logKariusEvent(EngagementEvents.user_profile_tapped);
    setAnchorEl(event.currentTarget);
  };

  const signOutUser = async () => {
    logKariusEvent(EngagementEvents.sign_out_tapped);
    setAnchorEl(null);
    signOut({ callbackUrl: '/login' });
  };

  if (!session?.user || !session?.user?.institution) {
    return null;
  }

  const {
    user: { name, email, institution, gravatarUrl },
  } = session;

  return (
    <>
      <ButtonBase
        aria-label='user-menu-button'
        data-test='signout-dropdown'
        onClick={handleClick}
        css={styles.container}
      >
        {gravatarUrl ? (
          <Image src={gravatarUrl} alt='Profile Image' width={26} height={26} css={styles.userIcon} />
        ) : (
          <AccountCircle css={styles.iconDefault} />
        )}
        <Box display='flex' flexDirection='column'>
          <Typography css={styles.userLabel}>{name}</Typography>
          <Typography css={styles.userLabel}>{institution?.name}</Typography>
        </Box>
        {anchorEl ? <ArrowDropUp /> : <ArrowDropDown />}
      </ButtonBase>
      <Menu
        aria-label='user-menu'
        keepMounted
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={!!anchorEl}
        onClose={handleClose}
        css={styles.menu}
      >
        <MenuItem disabled>{email}</MenuItem>
        <MenuItem data-test='signout-button' css={styles.logout} onClick={signOutUser}>
          Sign Out
        </MenuItem>
      </Menu>
    </>
  );
}
